import { get, post } from '../../config/$ajax.js'
import { getXyGylHost } from '@/utils/domainHelper.js';

// 获取平台配置
export const queryDistributionConfig = (data = {}, params = {}) => {
    return get('/dsb/queryDistributionConfig', data, params);
}
// 获取跨境平台配置
export const queryCrossborderConfig = (data = {}, params = {}) => {
    return get('/crossborder/config/get', data, params);
}
// 修改平台配置
export const editDistributionConfig = (data = {}) => {
    return post('/dsb/saveOrUpdateDistributionConfig', data, { submitType: 'json', headers: { 'Content-Type': 'application/json' } });
}
// 修改跨境平台配置
export const editCrossborderConfig = (data = {}) => {
    return post('/crossborder/config/save', data, { submitType: 'json', headers: { 'Content-Type': 'application/json' } });
}

// 获取快手运费模板
export const getKuaishouTemplateList = (data = {}) => {
    return get('/dsb/getKuaishouTemplateList', data, { isNeedLoading: false });
}
// 获取抖音运费模板
export const getDouyinTemplateList = (data = {}) => {
    return get('/dsb/getDouyinTemplateList', data, { isNeedLoading: false });
}
// 获取抖音供销平台运费模板
export const getDouyinGxTemplateList = (data = {}) => {
    return get('/dsb/getDouyinGxTemplateList', data, { isNeedLoading: false });
}

// 获取拼多多运费模板
export const getPinTemplateList = (data = {}) => {
    return get('/dsb/getPddTemplateList', data, { isNeedLoading: false });
}
// 获取京东运费模板
export const getJdTemplateList = (data = {}, config = {}) => {
    return get('/dsb/getJingdongTemplateList', data, { isNeedLoading: false, ...config, });
}
// 获取有赞运费模板
export const getYzTemplateList = (data = {}) => {
    return get('/dsb/getYouZanTemplateList', data, { isNeedLoading: false });
}
/**
 * 获取有赞零售店铺分类
 * @param {*} data 参数
 * @returns
 */
export const getYzRetailShopCategories = (data) => {
    return get('/yz/getCategory', data, { isNeedLoading: false });
}
// 获取淘宝运费模板
export const getTaobaoTemplateList = (data = {}) => {
    return get('/dsb/getTaobaoTemplateList', data, {
        isNeedLoading: false
    })
}
/**
 * 获取淘宝运费模板
 * @param {*} data 参数
 * @returns
 */
export const getTaobaoFreightTemplate = (data, params) => {
    return post('/dsb/queryFreightTemplate', data, {
        isNeedLoading: false,
        submitType: 'json',
        ...params
    }) 
}
/**
 * 淘宝运费模板刷新
 * @param {*} shopIdList
 * @param {*} platformType
 * @returns
 */
export const refreshTaobaoFreightTemplte = (shopIdList, platformType = 'tb') => {
    return post('/dsb/syncFreightTemplate', {
        shopIdList,
        platformType
    }, {
        isNeedLoading: false,
        submitType: 'json'
    }) 
}
/**
 * 查询淘宝店铺分类列表
 * @param {*} shopIdList
 * @param {*} platformType
 * @returns
 */
export const getTaobaoSellerCatsGet = (data, params) => {
    return get('/tb/sellerCatsGet', data, params) 
}

// 获取淘特运费模板列表
export const getTaoTeTemplateList = (data = {}) => {
    return get('/dsb/getTaoTeTemplateList', data, {
        isNeedLoading: false
    })
}
// 获取天猫运费模板
export const getTmallTemplateList = (data = {}) => {
    return get('/dsb/getTmallTemplateList', data, {
        isNeedLoading: false
    })
}
// 获取微信小店运费模板
export const getWxxdTemplateList = (data = {}) => {
    return get('/wxxd/getTemplateList', data, {
        isNeedLoading: false
    })
}
// 获取微店运费模版
export const getWdTemplateListApi = (data = {}) => {
    return get('/wd/getTemplateList', data, {
        isNeedLoading: false
    })
}

/**
 * 获取排序规则
 * @param {*} data 
 * @returns 
 */
export const getSortRules = (data = {}) => {
    return get('/shop/getSortRules', data)
}


/**
 * 修改排序规则
 * @param {*} data 
 * @returns 
 */
export const updateSortRules = (data = {}, params = { submitType: 'json' }) => {
    return post('/shop/saveOrUpdateSortRule', data, params)
}

/**
 * 获取公司商品是否同步erp
 * @param {*} data 
 * @returns 
 */
export const scmSyncErp = (data = {}) => {
    return get('/scmCompanyConf/search', data)
}

/**
 * 设置公司商品是否同步erp
 * @param {*} data 
 * @returns 
 */
export const  setScmSyncErp = (data ={}) => {
    return get('/scmCompanyConf/operate', data)
}

/**
 * 获取公司的配置
 * @param {*} data 
 * @returns 
 */
export const scmCompanyConfQuery = (data = {}) => {
    return post('/scmCompanyConf/queryConfig', data)
}
// 后端有缓存的
export const scmCompanyConfCacheQuery = (data = {}) => {
    return post('/scmCompanyConf/queryConfig/cache', data, { isNeedLoading: false })
}

/**
 * 更新公司的配置
 * @param {*} data 
 * @returns 
 */
export const scmCompanyConfSet = (data = {}) => {
    return post('/scmCompanyConf/upsetConfig', data, { submitType: 'json' })
}

/**
 * 获取商品同步管理的配置
 * @param {*} data 
 * @returns 
 */
 export const querySyncFiledConfig = (data = {}) => {
    return post('/scmCompanyConf/querySyncFiledConfig', data)
}

/**
 * 更新商品同步管理的配置
 * @param {*} data 
 * @returns 
 */
 export const editSyncConfig = (data = {}) => {
    return post('/scmCompanyConf/updateSyncFiledConfig', data, { submitType: 'json' })
}
/**
 * 上传图片至平台
 * @param {*} data
 * @returns
 */
export const uploadImageToPlatform = (data) => {
    return post('/image/uploadImageToPlatform', data, {
        isNeedLoading: false,
        submitType: 'json'
    }) 
}
/**
 * 查询平台图片状态
 * @param {*} data
 * @returns
 */
export const queryPlatFormImagesStatus = (data) => {
    return post('/image/queryPlatformImageStatus', data, {
        isNeedLoading: true,
        submitType: 'json'
    }) 
}
export const queryDistributionPriceConfig = params => {
    return post('/scmDistributionPriceConfig/queryPriceConfig', params).then(res => {
      return res.result == 1 ? res : Promise.reject(res);
    });
};

export const updateDistributionPriceConfig = params => {
    return post('/scmDistributionPriceConfig/savePriceConfig', params, { submitType: 'json' }).then(res => {
      return res.result == 1 ? res : Promise.reject(res);
    });
};

export const queryPlatformPriceConfig = params => {
    return post('/scmCompanyConf/queryPlatformPriceConfig', params).then(res => {
      return res.result == 1 ? res : Promise.reject(res);
    });
};

export const updatePlatformPriceConfig = params => {
    return post('/scmCompanyConf/updatePlatformPriceConfig', params, {submitType: 'json'}).then(res => {
      return res.result == 1 ? res : Promise.reject(res);
    });
};

// 获取类目属性模版配置列表
export const queryPlatformCatpropList = params => {
    return post('/platform/catprop/list', params, { submitType: 'json' }).then(res => {
        return res.result == 1 ? res.data || {} : {};
    });
};
// 获取类目属性模版ai列表
export const predictionCatProps = params => {
    return get('/publish/fast/prediction/cat/prop', params, { isNeedLoading: false }).then(res => {
        return res.result == 1 ? res.data || null : null;
    });
};

// 新增或者编辑类目属性模版配置
export const saveOrUpdatePlatformCatprop = params => {
    return post('/platform/catprop/saveOrUpdateConfig', params, { submitType: 'json' }).then(res => {
        return res.result == 1;
    });
};
// 删除类目属性模版配置
export const deletePlatformCatprop = params => {
    return get('/platform/catprop/delete', params).then(res => {
        return res.result == 1;
    });
};
// 查看类目属性模版日志
export const getPlatformCatpropLogList = params => {
    return get('/platform/catprop/logList', params).then(res => {
        return res.result == 1 ? res.data || {} : {};
    });
};

// 获取添加店铺免登地址
export const exemptionOtherPlatApi = (data = {}) => {
    return get(`//${getXyGylHost()}/api/accountGyl/exemptionOtherPlat`, data, {
        isNeedLoading: false
    })
}

// ==================== 类目映射相关 ====================
// 分页查询类目映射列表
export const getCategoryMappingPage = (data) => {
    return post('/item/category-mapping/page', data, { appJson: true, submitType: 'json', isNeedLoading: true })
}
// 新增或编辑类目映射
export const saveCategoryMapping = (data) => {
    return post('/item/category-mapping/save', data, { appJson: true, submitType: 'json', isNeedLoading: true })
}
// 批量删除类目映射
export const deleteCategoryMapping = (data) => {
    return post('/item/category-mapping/delete', data, { isNeedLoading: true })
}
// 批量开启/关闭类目映射
export const updateCategoryMappingStatus = (data) => {
    return post('/item/category-mapping/updateStatus', data, {  isNeedLoading: true })
}

// ==================== 产品参数图片类目配置相关 ====================
// 产品参数图片 - 类目配置 - 查询
export const queryCategoryImageConfig = (data = {}) => {
    return get('/dsb/queryCategoryImageConfig', data)
}
// 产品参数图片 - 类目配置 - 保存
export const saveOrUpdateCategoryImageConfig = (data = {}) => {
    return post('/dsb/saveOrUpdateCategoryImageConfig', data, { submitType: 'json' })
}
// 产品参数图片 - 类目配置 - 删除
export const deleteCategoryImageConfig = (data = {}) => {
    return get('/dsb/deleteCategoryImageConfig', data)
}
// 产品参数图片 - 根据类目查询（按类目优先，然后通用配置）
export const queryCategoryConfigInfo = (data = {}) => {
    return get('/dsb/queryCategoryConfigInfo', data)
}
